// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.top-matter .breadcrumb[data-v-087bdb11]{min-width:0;height:unset}.top-matter .breadcrumb .share-name[data-v-087bdb11]{margin-left:.75em}.top-matter .right-actions[data-v-087bdb11]{display:flex;align-items:center;gap:10px}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
